import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaymentFailed = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const details = {
      transactionId: params.get('transactionId') || 'Failed Transaction',
      amount: params.get('amount') || '0',
      planName: params.get('planName') || 'Premium Plan',
      errorMessage: params.get('errorMessage') || 'Payment could not be processed'
    };
    setPaymentDetails(details);
  }, [location]);

  const handleRetryPayment = () => {
    navigate(-2); // Go back to payment
  };

  const handleBackToPlans = () => {
    navigate('/home/settings/pricing');
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '600px',
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '40px',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#f44336',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px'
        }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
          </svg>
        </div>

        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: '700',
          color: '#f44336',
          marginBottom: '16px'
        }}>
          Payment Failed 😞
        </h1>

        <p style={{
          fontSize: '1.2rem',
          color: '#666',
          marginBottom: '30px'
        }}>
          We couldn't process your payment. No charges were made.
        </p>

        {paymentDetails && (
          <div style={{
            backgroundColor: '#fef2f2',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Transaction Details</h3>
            
            <div style={{ display: 'grid', gap: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Plan:</span>
                <span style={{ fontWeight: '600' }}>{decodeURIComponent(paymentDetails.planName)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Amount:</span>
                <span style={{ fontWeight: '600' }}>₹{paymentDetails.amount}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Error:</span>
                <span style={{ color: '#f44336', fontSize: '0.9rem' }}>{paymentDetails.errorMessage}</span>
              </div>
            </div>
          </div>
        )}

        <div style={{
          backgroundColor: '#fff3cd',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '30px',
          textAlign: 'left'
        }}>
          <h4 style={{ margin: '0 0 12px 0', color: '#856404' }}>Common reasons:</h4>
          <ul style={{ margin: '0', paddingLeft: '20px', color: '#856404', fontSize: '0.9rem' }}>
            <li>Insufficient funds in account</li>
            <li>Card expired or blocked</li>
            <li>Incorrect card details</li>
            <li>Network connectivity issues</li>
          </ul>
        </div>

        <div style={{ display: 'grid', gap: '12px' }}>
          <button
            onClick={handleRetryPayment}
            style={{
              width: '100%',
              padding: '16px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            🔄 Try Again
          </button>

          <button
            onClick={handleBackToPlans}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: 'transparent',
              color: '#666',
              border: '1px solid #ddd',
              borderRadius: '8px',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            Back to Plans
          </button>
        </div>

        <p style={{ fontSize: '0.9rem', color: '#999', marginTop: '20px' }}>
          Need help? Contact <strong>support@galile.io</strong>
        </p>
      </div>
    </div>
  );
};

export default PaymentFailed;